import { RestaurantLogo } from '@/components/brand/restaurant-logo';
import { Link } from 'react-router-dom';

export const SiteFooter = () => (
  <footer className="border-t border-ink-200 bg-white">
    <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-10 text-sm text-ink-500 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <div>
        <p className="group flex items-center gap-2 font-display text-base font-bold text-ink-800">
          <RestaurantLogo size={28} />
          Grow My Restaurant
        </p>
        <p className="mt-1">Free website grades for independent restaurants.</p>
      </div>
      <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2">
        <Link to="/grade" className="hover:text-ink-800">
          Grade a website
        </Link>
        <Link to="/login" className="hover:text-ink-800">
          Sign in
        </Link>
        <a href="/#how-it-works" className="hover:text-ink-800">
          How it works
        </a>
        <a href="/#faq" className="hover:text-ink-800">
          FAQ
        </a>
      </nav>
      <p>© {new Date().getFullYear()} Grow My Restaurant</p>
    </div>
  </footer>
);
